import React from 'react';
import { PhoneCarouselContentfulModel } from 'src/api/models/PhoneCarousel';
import Paragraph from 'src/elements/typography/paragraph';
import Heading from '../../elements/typography/heading';
import { CarouselContainer, PhoneCarouselContainer, PhoneCarouselContent, PhoneCarouselTextContainer } from './PhoneCarousel.engagementDrop.styles';
import PhoneCarouselWrapper from './PhoneCarouselWrapper';

interface PhoneCarouselEngagementDropProps {
  phoneItems: PhoneCarouselContentfulModel['contentfulchildren'];
  title: string;
  description: string;
}

const PhoneCarouselEngagementDrop = ({ phoneItems, title, description }: PhoneCarouselEngagementDropProps): JSX.Element => {
  return (
    <PhoneCarouselContainer>
      <PhoneCarouselContent>
        <PhoneCarouselTextContainer>
          <Heading
            text={title}
            color="#ffffff"
            size="4rem"
            sizeLg="3.6rem"
            sizeSm="1.8rem"
            align="center"
          />
          <Paragraph
            text={description}
            size="2rem"
            sizeSm="1.3rem"
            color="#ffffff"
            align="center"
            weight="light"
          />
        </PhoneCarouselTextContainer>
        <CarouselContainer>
          <PhoneCarouselWrapper
            phoneItems={phoneItems}
            chevronColor="#ffffff"
            mobileDots
            showAllCaptions
          />
        </CarouselContainer>
      </PhoneCarouselContent>
    </PhoneCarouselContainer>
  );
}

export default PhoneCarouselEngagementDrop;
